import { getRequest } from 'src/lib/api-client'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

export const checkUsernameAvailability = async (username: string) => {
  return getRequest<PublicUserData>(`/users/username-available?username=${username}`)
}
